import { get } from '../../utils/ajax';
import { aggregateData } from '../../utils/aggrigateData';

export const REQUEST_STARTED = 'data/REQUEST_STARTED';
export const REQUEST_SUCCEEDED = 'data/REQUEST_SUCCEEDED';
export const REQUEST_SUCCEEDED_LITE = 'data/REQUEST_SUCCEEDED_LITE';
export const REQUEST_FAILED = 'data/REQUEST_FAILED';
export const REQUEST_REGION_SELECT = 'data/REQUEST_REGION_SELECT';
export const SET_COORDINATES = 'data/SET_COORDINATES';
export const SET_ADDRESS = 'data/SET_ADDRESS';

function requestStarted() {
  return {
    type: REQUEST_STARTED,
  };
}

function requestSucceeded(data, partyData, geoPP, dataRadius, totalVotes) {
  return {
    type: REQUEST_SUCCEEDED,
    data,
    partyData,
    geoPP,
    dataRadius,
    totalVotes,
  };
}

function requestSucceededLite(data) {
  return {
    type: REQUEST_SUCCEEDED_LITE,
    data,
  };
}

function requestFailed(error) {
  return {
    type: REQUEST_FAILED,
    error,
  };
}

export function handleRegionSelect(region) {
  return {
    type: REQUEST_REGION_SELECT,
    region,
  };
}

export function handleSetCoordinates(coords) {
  return {
    type: SET_COORDINATES,
    coords,
  };
}

export function handleAddress(address) {
  return {
    type: SET_ADDRESS,
    address,
  };
}

const files = [
  {
    region: 'ACT',
    file: 'fp-ACT.json',
  },
  {
    region: 'NSW',
    file: 'fp-NSW.json',
  },
  {
    region: 'NT',
    file: 'fp-NT.json',
  },
  {
    region: 'QLD',
    file: 'fp-QLD.json',
  },
  {
    region: 'SA',
    file: 'fp-SA.json',
  },
  {
    region: 'TAS',
    file: 'fp-TAS.json',
  },
  {
    region: 'VIC',
    file: 'fp-VIC.json',
  },
  {
    region: 'WA',
    file: 'fp-WA.json',
  },
];

export function fetchData(calcLocations = false) {
  return (dispatch, getState) => {
    const state = getState(); // eslint-disable-line no-unused-vars
    dispatch(requestStarted());

    const curRegion = state.data.region;
    console.log('in curRegtion ', curRegion);

    function getData(d) {
      return new Promise((resolve) => {
        get(d).then((e) => {
          resolve(JSON.parse(e));
        });
      });
    }

    async function init() {
      try {
        const f = files.find((obj) => {
          return obj.region === curRegion;
        });
        console.log('get f ', f);

        const d = await getData(`data/${f.file}`);
        //
        if (calcLocations) {
          const agObj = aggregateData(d, state.data.coords);
          dispatch(
            requestSucceeded(
              d,
              agObj.partyData,
              agObj.geoPP,
              agObj.dataRadius,
              agObj.totalVotes,
            ),
          );
        } else {
          dispatch(requestSucceededLite(d));
        }
      } catch (err) {
        dispatch(requestFailed(err));
      }
    }
    init();
  };
}
